import { ReactNode } from "react";
import { Breadcrumbs, BreadcrumbsProps } from "@/components/Common/Breadcrumbs";

type BreadcrumbPageProps = BreadcrumbsProps & {
  children: ReactNode;
  header?: ReactNode;
};

export const BreadcrumbPage = ({
  children,
  header,
  breadcrumbs,
}: BreadcrumbPageProps) => {
  return (
    <div className="flex h-full flex-col gap-4 print:block print:h-auto print:bg-white print:p-0">
      <div className="px-4 py-2 print:hidden">
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>
      <div className="print:hidden">{header}</div>
      <div className="overflow-auto p-4 print:h-auto print:overflow-visible print:p-0">
        {children}
      </div>
    </div>
  );
};
